import {Record as record} from 'immutable';

export default record(
    {
        arrivedFromEmail: false,
        arrivedFromExternalSite: false,
        arrivedFromFacebook: false,
        cookies: {},
        displayCivilCodeDisclaimerLink: false,
        hasTripInsurance: false,
        hasClevacances: false,
        hasBearStay: false,
        hasRecentGeoSearch: false,
        hasWriteReviews: false,
        includeTaxesAndFees: false,
        inquiryPhoneIsMobile: false,
        isLoggedIn: false,
        showTotal: false,
        termsAndConditionsRequired: false,
        displayImprint: false,
        hasReportReviewLink: false,
        showReviewsLegalDisclaimer: false,
        twitterUsername: 'HomeAway'
    },
    'TravelerFeatures'
);
